import React, { useRef } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";

const BULL_IMAGE = "https://customer-assets.emergentagent.com/job_pod-istres-hb/artifacts/i947ldbm_Istres-HANDBALL-TAUREAU-BLANC.png";

/**
 * ParallaxBull — taureau qui glisse de gauche à droite (ou inverse) lorsqu'on scrolle dans la section.
 *
 * Props:
 *  - direction: "ltr" | "rtl" (default "ltr")
 *  - height: hauteur en px du taureau (default 280)
 *  - opacity: transparence (default 0.18)
 *  - color: tint via filter (default white)
 *  - rotate: rotation en deg (default 0)
 */
export default function ParallaxBull({
  direction = "ltr",
  height = 280,
  opacity = 0.18,
  rotate = 0,
  containerRef = null,
}) {
  const localRef = useRef(null);
  const ref = containerRef || localRef;
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  // smooth spring
  const smooth = useSpring(scrollYProgress, { stiffness: 80, damping: 22, restDelta: 0.001 });
  // map progress -> X percentage
  const xPct = useTransform(
    smooth,
    [0, 1],
    direction === "ltr" ? ["-30%", "115%"] : ["115%", "-30%"]
  );
  const rot = useTransform(smooth, [0, 1], [rotate - 4, rotate + 4]);
  const scale = useTransform(smooth, [0, 0.5, 1], [0.95, 1.05, 0.95]);

  return (
    <div ref={ref} className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
      <motion.img
        src={BULL_IMAGE}
        alt=""
        style={{
          x: xPct,
          rotate: rot,
          scale,
          height,
          width: "auto",
          maxWidth: "none",
          opacity,
          top: "50%",
          translateY: "-50%",
          objectFit: "contain",
          filter: "drop-shadow(0 10px 30px rgba(236,31,124,0.4))",
        }}
        className="absolute"
      />
    </div>
  );
}
